import React, { useContext, useState } from "react";
import { GlobalContext } from "../context/provider";
import checkaction from "../context/action/login/checkaction";
import { FaUserAlt, FaLock } from "react-icons/fa";

const Login = () => {
  const { initState, initDispatch, recaller, setrecaller } =
    useContext(GlobalContext);

  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");

  const [errorUser, setErrorUser] = useState(false);
  const [errorPass, setErrorPass] = useState(false);

  const handleLogin = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    if (!username.trim()) {
      setErrorUser(true);
      return;
    }
    if (!password.trim()) {
      setErrorPass(true);
      return;
    }
    initDispatch({ type: "authcheckFalse" });
    checkaction(username, password)(initDispatch)(recaller)(setrecaller);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-blue-300 px-4">
      <div className="bg-white shadow-xl rounded-2xl w-full max-w-md p-8">
        {/* Title */}
        <h1 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-6">
          Welcome Back
        </h1>

        {/* Username */}
        <div className="mb-4">
          <label
            className={`block text-sm font-medium mb-1 ${
              errorUser ? "text-red-500" : "text-gray-700"
            }`}
            htmlFor="username"
          >
            Username
          </label>
          <div className="relative">
            <FaUserAlt className="absolute left-3 top-3 text-gray-400" />
            <input
              id="username"
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setusername(e.target.value)}
              onFocus={() => setErrorUser(false)}
              className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errorUser
                  ? "border-red-500 focus:ring-red-400"
                  : "border-gray-300 focus:ring-blue-400"
              }`}
            />
          </div>
        </div>

        {/* Password */}
        <div className="mb-4">
          <label
            className={`block text-sm font-medium mb-1 ${
              errorPass ? "text-red-500" : "text-gray-700"
            }`}
            htmlFor="password"
          >
            Password
          </label>
          <div className="relative">
            <FaLock className="absolute left-3 top-3 text-gray-400" />
            <input
              id="password"
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setpassword(e.target.value)}
              onFocus={() => setErrorPass(false)}
              className={`w-full pl-10 pr-3 py-2 border rounded-lg focus:outline-none focus:ring-2 ${
                errorPass
                  ? "border-red-500 focus:ring-red-400"
                  : "border-gray-300 focus:ring-blue-400"
              }`}
            />
          </div>
        </div>

        {/* Error message */}
        {initState.authcheck && (
          <div className="text-center text-red-600 font-semibold mb-4">
            Username or password incorrect
          </div>
        )}

        {/* Button */}
        <button
          onClick={handleLogin}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 rounded-lg transition duration-300"
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Login;
